import React from "react"
import IntroSection from "../components/IntroSection"
import AISolutions from "../components/AISolutions";
import BlueSectionDivider from "../components/BlueSectionDivider";
import AIProcess from "../components/AIProcess";
import CustomerTestimonials from "../components/CustomerTestimonials";
import AIBenefits from "../components/AIBenefits";
import AIAwards from "../components/AIAwards";
import AIReimagine from "../components/AIReimagine";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import AIFaq from "../components/AIFaq";
import AIResources from "../components/AIResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
const AI_DS = () => {
    return (
        <div>
            <IntroSection title="DATA SCIENCE & ARTIFICIAL INTELLIGENCE" paragraph="Turn data into competitive advantage with custom DS and AI systems." backgroundImage="/images/ai-bg.webp"/>
            <AISolutions/>
            <BlueSectionDivider/>
            <AIProcess/>
           
            <AIBenefits/>
           
            <BlueSectionDivider/>
            <AIReimagine/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <AIFaq/>
            <BlueSectionDivider/>
            
           <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>


        </div>
    )
}
export default AI_DS;